export default "__VITE_ASSET__rAyFmqQR5K2RinDrmNFkvg__"